import { useEffect, useState } from 'react';
import { NextPage } from 'next';

import { useRouter } from 'next/router';

import errorPageImage from '/public/images/error-page-image.svg';
import { BasicLayout } from '@/components/layouts/basic-layout';
import { Loader } from '@/components/loader';
import { FINISH_ON_BOARDING_KEY } from '@/constants/localstorage.constants';
import { StatusCode } from '@/services/http/http.types';
import { OnBoardingStep, Page } from '@/types/pages.types';
import { getConsent } from '@/utils/requests.utils';
import { buildTokenizedUrl, getDefaultRedirectPath } from '@/utils/url.utils';

const Index: NextPage = () => {
  const [isError, setIsError] = useState(false);
  const { push, query, isReady } = useRouter();

  useEffect(
    function redirect() {
      const redirectToPage = async () => {
        try {
          const { hasConsent } = await getConsent();

          if (!hasConsent) {
            push(buildTokenizedUrl(query?.token as string, Page.Consent));
            return;
          }

          push(getDefaultRedirectPath(query?.token as string));
        } catch (error: any) {
          if (error.statusCode === StatusCode.Unauthorized) {
            const isFinishOnBoarding = localStorage.getItem(FINISH_ON_BOARDING_KEY);

            if (isFinishOnBoarding) {
              push(buildTokenizedUrl(query?.token as string, Page.Login));
            } else {
              push(
                buildTokenizedUrl(
                  query?.token as string,
                  Page.OnBoarding,
                  `step=${OnBoardingStep.One}`
                )
              );
            }
            return;
          }

          setIsError(true);
        }
      };

      if (!isReady) {
        return;
      }

      redirectToPage();
    },
    [query?.token, push, isReady]
  );

  if (isError) {
    return (
      <BasicLayout
        title="Oops..."
        description={'Sorry, something went wrong.\n Please contact your care team'}
        image={errorPageImage}
      />
    );
  }

  return <Loader />;
};

export default Index;
